import React from 'react';
import { useAdminContext } from './adminContext';
import { AdminAutomationsModule } from '../../components/admin/AdminAutomationsModule';

export function AdminAutomationsPage() {
  const { adminKey } = useAdminContext();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <AdminAutomationsModule adminKey={adminKey} />
    </div>
  );
}

export default AdminAutomationsPage;
